module.exports = __webpack_public_path__ + "static/media/new_login_bsa_bg_1.c27ffb39.png";